jQuery(function($) {
    const currentSearchPage = getCurrentSearch();
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    const children = document.querySelectorAll(".rt-filter-select");
    for (let child of children) {
        child.classList.remove('rt-filter-selected');
        child.ariaPressed = false;
    }
    if (currentSearchPage != null && params.miasto) {
        markAsSelected(document.querySelector('.rt-filter-item-miasto-' + params.miasto));
    }  else if (currentSearchPage != null) {
        markAsSelected(document.querySelector('.rt-filter-item-miasto-all'));
    }
    if (currentSearchPage === 'projekty' && params.status) {
        markAsSelected(document.querySelector('.rt-filter-item-status-' + params.status));
    } else if (currentSearchPage === 'projekty') {
        markAsSelected(document.querySelector('.rt-filter-item-status-all'));
    }
    if (currentSearchPage === 'projekty' && params.grupa_docelowa) {
        markAsSelected(document.querySelector('.rt-filter-item-grupa_docelowa-' + params.grupa_docelowa));
    } else if (currentSearchPage === 'projekty') {
        markAsSelected(document.querySelector('.rt-filter-item-grupa_docelowa-all'));
    }
    if (currentSearchPage === 'zasoby' && params.zasoby_typ) {
        markAsSelected(document.querySelector('.rt-filter-item-zasoby_typ-' + params.zasoby_typ));
    } else if (currentSearchPage === 'zasoby') {
        markAsSelected(document.querySelector('.rt-filter-item-zasoby_typ-all'));
    }
    if (currentSearchPage === 'projekty' && params.grupa_docelowa) {
        markAsSelected(document.querySelector('.rt-filter-item-grupa_docelowa-' + params.grupa_docelowa));
    } else if (currentSearchPage === 'projekty') {
        markAsSelected(document.querySelector('.rt-filter-item-grupa_docelowa-all'));
    }
    if (currentSearchPage === 'kariera' && params.stanowisko) {
        markAsSelected(document.querySelector('.rt-filter-item-stanowisko-' + params.stanowisko));
    } else if (currentSearchPage === 'kariera') {
        markAsSelected(document.querySelector('.rt-filter-item-stanowisko-all'));
    }
    searchProjects();
});

function selectFilter(el, type, value) {
    const url = new URL(window.location.href);
    if(value) {
        url.searchParams.set(type, value);
    } else {
        url.searchParams.delete(type);
    }
    window.history.replaceState(null, null, url);
    updateSelectFilterClass(el, type);
    searchProjects();
}

function updateSelectFilterClass(el, type) {
    const children = document.querySelector('.rt-filter-row-' + type).querySelectorAll(".rt-filter-select");

    for (let child of children) {
        child.classList.remove('rt-filter-selected');
        child.ariaPressed = false;
    }
    markAsSelected(el);
}

function markAsSelected(el) {
    if (el) {
        el.classList.add('rt-filter-selected');
        el.ariaPressed = true;
    }
}


function searchProjects() {
    currentSearchPage = getCurrentSearch();
    if (currentSearchPage) {
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        const tags = [currentSearchPage];
        if (params.miasto) {
            const city = params.miasto.charAt(0).toUpperCase() + params.miasto.slice(1)
            tags.push(params.miasto);
        } 
        if (currentSearchPage === 'projekty' && params.status) {
            const status = params.status.charAt(0).toUpperCase() + params.status.slice(1)
            tags.push(status);
        } 
        if (currentSearchPage === 'projekty' && params.grupa_docelowa) {
            tags.push(params.grupa_docelowa);
        } 
        if (currentSearchPage === 'zasoby' && params.zasoby_typ) {
            tags.push(params.zasoby_typ);
        }
        if (currentSearchPage === 'projekty' && params.grupa_docelowa) {
            tags.push(params.grupa_docelowa);
        }
        if (currentSearchPage === 'kariera' && params.stanowisko) {
            tags.push(params.stanowisko);
        }
        searchProjectsByTag(tags);
    }
}

function getCurrentSearch() {
    switch (window.location.pathname)
    {
        case "/aktualnosci/":
            return "aktualnosci";
        case "/nasze-projekty/":
            return "projekty";
        case "/zasoby/":
            return "zasoby";
        case "/kariera/":
            return "kariera";
        default:
            return null;
    }
}

function searchProjectsByTag(tags = []) {
    var ghostAPI = new GhostContentAPI({
        url: window.location.origin,
        key: config['content-api-key'],
        version: 'v5.0'
    });

    var filter = tags.toString();
    filter = tags.map((tag) => "tag:" + tag ).join("+");
    ghostAPI.posts
        .browse({limit: 'all', filter: filter, include: 'tags'})
        .then(function(results){
            $('.rt-page-posts-list').empty();
            if(results.length > 0) {
                $.each(results, function(index, post) {
                    $('.rt-page-posts-list').append(preparePostCard(post));
                });
            } else {
                $('.rt-page-posts-list').append('<div>Nie znaleziono wyników</div>')
            }
            
        })
        .catch(function(err){
            console.error(err);
        });
}

function preparePostCard(post) {
    let monthNames = ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "List", "Paź", "Gru"];
    var dateSplit = post.published_at.split('T');
    dateSplit = dateSplit[0].split('-');
    var month = monthNames[dateSplit[1]-1];
    var dateText = dateSplit[2]+' '+month+' '+dateSplit[0];
    return  '<a class="tr-post-card" href="' + post.url + '">' +
                prepareFeatureImage(post) + 
                '<div class="tr-post-card-info">' +
                    '<div class="tr-post-card-tag">' +
                        prepareTags(post.tags) + 
                    '</div>' +
                    '<div class="tr-post-card-title">' + 
                        '<h3>' +
                            post.title + 
                        '</h3>'+
                    '</div>' +
                    '<div class="tr-post-card-labels">' +
                        '<div class="tr-post-card-label">' +
                            '<img width="14" height="14" class="rt-arrow" src="/assets/icons/calendar.svg" alt=""/>' + 
                            dateText +
                        '</div>' +
                        '<div class="tr-post-card-label">' +
                            '<img width="14" height="14" class="rt-arrow" src="/assets/icons/clock.svg" alt=""/>' + 
                            (post.reading_time || 1) + ' min czytania' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="tr-post-card-excerpt">' +
                     (post.custom_excerpt || post.excerpt) +
                '</div>' +
            '</a>'
}

function prepareFeatureImage(post) {
    if (post.feature_image) {
        return '<div class="tr-post-card-image">' +
            '<img src="' + post.feature_image + '" width="628" height="353" alt=""/>' +
        '</div>';
    } else {
        return '';
    }
   
}

function prepareTags(tags = []) {
    return tags.map(tag => {
        return '<div class="tr-tag-chip">' +
                    tag.name +
                '</div>'
    }).join('');
}